import { useQuery } from '@tanstack/react-query';

import { SuggestedMeetingView } from '@ndvr/customer-api';

import { CustomerApi } from 'API';

export const SuggestedMeetingQueryKeys = {
    byNote: (noteGUID: string) => ['SuggestedMeetings', noteGUID] as const,
} as const;

// Endpoint plus the by-note query it makes stale, so every dismiss caller invalidates the same key.
export const suggestedMeetingDismissal = (suggestedMeetingGUID: string, noteGUID: string) => ({
    request: () => CustomerApi().dismissSuggestedMeeting(suggestedMeetingGUID),
    staleQueryKey: SuggestedMeetingQueryKeys.byNote(noteGUID),
});

export const useSuggestedMeetingsByNoteQuery = <TData = SuggestedMeetingView[]>(
    noteGUID: string,
    options?: { select?: (suggestions: SuggestedMeetingView[]) => TData },
) =>
    useQuery<SuggestedMeetingView[], Error, TData>({
        enabled: !!noteGUID,
        queryKey: SuggestedMeetingQueryKeys.byNote(noteGUID),
        queryFn: async () => {
            const [response] = await CustomerApi().getSuggestedMeetingsByNoteGUID({ noteGUID });
            return response ?? [];
        },
        ...options,
    });
